// extracted by mini-css-extract-plugin
export var actions = "_d5-g";
export var benefitCard = "_d5-b";
export var benefitIcon = "_d5-d";
export var benefitLabel = "_d5-f";
export var benefits = "_d5-a";
export var benefitsSection = "_d5-8";
export var bodyText = "_d5-7";
export var closeButton = "_d5-2";
export var content = "_d5-3";
export var eyebrow = "_d5-4";
export var heading = "_d5-5";
export var image = "_d5-i";
export var imagePanel = "_d5-h";
export var modal = "_d5-0";
export var offerCard = "_d5-c";
export var offerIcon = "_d5-e";
export var sectionLabel = "_d5-9";
export var shell = "_d5-1";
export var title = "_d5-6";